import { TablePagination } from "@mui/material";
import { useStateWithSearchParams } from "../../../hooks";

const PER_PAGE = [10, 25, 50];

type SearchParams = {
  page?: string;
  per_page?: string;
};

export const AccountListPagination = ({ totalRows }: { totalRows: number }) => {
  const { searchDict, setSearchValue } = useStateWithSearchParams<SearchParams>(
    {
      page: undefined,
      per_page: undefined,
    },
  );

  const handleChangePage = (_: unknown, newPage: number) => {
    setSearchValue("page", String(newPage));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setSearchValue("per_page", String(newRowsPerPage));
  };

  return (
    <TablePagination
      rowsPerPageOptions={PER_PAGE}
      component="div"
      count={totalRows}
      rowsPerPage={Number(searchDict.per_page) || PER_PAGE[1]}
      page={Number(searchDict.page) || 0}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  );
};
